import {BASE_TRACK_API_URL} from "@constants/config";
import {apiRequestWithAuth} from "@helpers/query/apiRequestWithAuth";
import {IPropsGetRelatedAccounts, RelatedAccountsData} from "@containers/account/types";
import {TypeOnErrorFn} from "@helpers/query/types";
import {serialize} from "@helpers/query/serialize";


const BASE_URL_ACCOUNTS = `${BASE_TRACK_API_URL}/v1/accounts`
export const getRelatedAccounts = async ({accountId, ...rest}: IPropsGetRelatedAccounts, onError: TypeOnErrorFn) => {
    const url = `${BASE_URL_ACCOUNTS}/${accountId}/relative-accounts?` + serialize(rest)
    return await apiRequestWithAuth<RelatedAccountsData>({
        url,
        options: {
            method: "GET",
        },
        onError
    });
};


export const getMultiAccounts = async (onError: TypeOnErrorFn) => {
    const url = `${BASE_URL_ACCOUNTS}/multi-accounts`
    return await apiRequestWithAuth<RelatedAccountsData>({
        url,
        options: {
            method: "GET",
        },
        onError
    });
};